const THEME_URL = (window.MiniNMT && window.MiniNMT.themeUrl) ? window.MiniNMT.themeUrl : '';

const QUESTIONS = [
  // === МАТЕМАТИКА (1-5) ===
  {
    subject: 'Математика',
    subjectKey: 'math',
    text: 'Якому проміжку належить корінь рівняння log0,5​x=−2?',
    answers: [
      { letter: 'А', text: '(−∞; −1]', points: 0 },
      { letter: 'Б', text: '(−1; 1]', points: 0 },
      { letter: 'В', text: '(1; 4]', points: 10 },
      { letter: 'Г', text: '(4; 8]', points: 0 },
      { letter: 'Д', text: '(8; +∞)', points: 0 },
    ],
  },
  {
    subject: 'Математика',
    subjectKey: 'math',
    text: 'Різниця арифметичної прогресії(a<sub>n</sub>) дорівнює 4. Обчисліть значення виразу a<sub>5</sub>−a<sub>3</sub>',
    answers: [
      { letter: 'А', text: '−8', points: 0 },
      { letter: 'Б', text: '−4', points: 0 },
      { letter: 'В', text: '8', points: 10 },
      { letter: 'Г', text: '0', points: 0 },
      { letter: 'Д', text: '4', points: 0 },
    ],
  },
  {
    subject: 'Математика',
    subjectKey: 'math',
    text: 'Обчисліть значення виразу: (0,3)<sup>2</sup> × 10<sup>4</sup> =',
    answers: [
      { letter: 'А', text: '600', points: 0 },
      { letter: 'Б', text: '900', points: 10 },
      { letter: 'В', text: '6000', points: 0 },
      { letter: 'Г', text: '9000', points: 0 },
      { letter: 'Д', text: '363^636', points: 0 },
    ],
  },
  {
    subject: 'Математика',
    subjectKey: 'math',
    text: 'Розв\'яжіть нерівність: (2x + 1)^2 < 9.',
    answers: [
      { letter: 'А', text: '(−1; 2)', points: 0 },
      { letter: 'Б', text: '(−∞; −2) ∪ (1; +∞)', points: 0 },
      { letter: 'В', text: '(−∞; −2)', points: 0 },
      { letter: 'Г', text: '(−∞; −1) ∪ (2; +∞)', points: 0 },
      { letter: 'Д', text: '(−2; 1)', points: 20 },
    ],
  },
  {
    subject: 'Математика',
    subjectKey: 'math',
    text: 'Які з наведених тверджень є правильними?\n<br><span>I. Пряма, що проходить через центр кола і лежить із цим колом в одній площині, має з ним дві спільні точки.\n</span><br><span>II. Діаметр кола, перпендикулярний до його хорди, проходить через середину цієї хорди.\n</span><br><span>III. Можна провести два діаметри кола, що не мають жодної спільної точки.</span>',
    answers: [
      { letter: 'А', text: 'лише II', points: 20 },
      { letter: 'Б', text: 'лише I та III', points: 0 },
      { letter: 'В', text: 'лише II та III', points: 0 },
      { letter: 'Г', text: 'лише I та II', points: 0 },
      { letter: 'Д', text: 'І, ІІ та ІІІ', points: 0 },
    ],
  },
  // === УКРАЇНСЬКА МОВА (6-10) ===
  {
    subject: 'Українська мова',
    subjectKey: 'ukr',
    text: 'Позначте рядок, у якому в усіх словах наголошений другий склад:',
    answers: [
      { letter: 'А', text: 'дочка, подруга, вимова, гуртожиток, русло', points: 0 },
      { letter: 'Б', text: 'новий, спина, виразно, завдання, попереду', points: 0 },
      { letter: 'В', text: 'предмет, рукопис, ненавидіти, фартух, в\'язкий', points: 10 },
      { letter: 'Г', text: 'середина, дефіс, старий, горошина, каталог', points: 0 },
      { letter: 'Д', text: 'легкий, олень, несла, добуток, партер', points: 0 },
    ],
  },
  {
    subject: 'Українська мова',
    subjectKey: 'ukr',
    text: 'Подвоєння літер у всіх словах іншомовного походження НЕ відбувається в рядку',
    answers: [
      { letter: 'А', text: 'нет..о, інтел..ект, шас..і', points: 0 },
      { letter: 'Б', text: 'нер..аціональний, ір..аціональний, тер..иторіальний', points: 0 },
      { letter: 'В', text: 'ем..іграція, ім..іграція, ап..еляція', points: 0 },
      { letter: 'Г', text: 'барок..о, коміс..ія, тер..ор', points: 15 },
      { letter: 'Д', text: 'ва..на, кор..ектура, грам..', points: 0 },
    ],
  },
  {
    subject: 'Українська мова',
    subjectKey: 'ukr',
    text: 'Лексична помилка є в реченні',
    answers: [
      { letter: 'А', text: 'Аліна, не дивлячись на жвавий, веселий характер, читала серйозні книжки на історичну тематику.', points: 15 },
      { letter: 'Б', text: 'Відвідавши мальовниче Закарпаття та зробивши багато ескізів, Михайло впевнився у своєму покликанні бути художником.', points: 0 },
      { letter: 'В', text: 'Закінчивши навчання на факультеті журналістики, Назар влаштувався в столичне видання на посаду літературного редактора.', points: 0 },
      { letter: 'Г', text: 'Здобувши вищу економічну освіту, Валентина вирішила відкрити фірму в рідному місті.', points: 0 },
      { letter: 'Д', text: 'Функціонуючи в різних куточках планети, студентські організації не припиняють співпраці – і це дає плідні результати.', points: 0 },
    ],
  },
  {
    subject: 'Українська мова',
    subjectKey: 'ukr',
    text: 'Граматично НЕПРАВИЛЬНЕ продовження речення «Добираючи збалансовану дієту,..» наведено в рядку',
    answers: [
      { letter: 'А', text: 'ураховуйте користь її не лише для вашого тіла, а й для розуму.', points: 0 },
      { letter: 'Б', text: 'переконайтеся, що отримаєте достатню кількість необхідних білків.', points: 0 },
      { letter: 'В', text: 'правильне харчування буде корисним для вашого здоров\'я загалом.', points: 15 },
      { letter: 'Г', text: 'до свого раціону додайте овочі й фрукти, багаті на клітковину.', points: 0 },
    ],
  },
  {
    subject: 'Українська мова',
    subjectKey: 'ukr',
    text: 'Граматично правильно утворено словосполучення',
    answers: [
      { letter: 'А', text: 'програміст по професії', points: 0 },
      { letter: 'Б', text: 'відправити по пошті', points: 0 },
      { letter: 'В', text: 'виплатити по сто гривень', points: 15 },
      { letter: 'Г', text: 'дбайливий по відношенню до майна', points: 0 },
      { letter: 'Д', text: 'подорожувати по європейським країнам', points: 0 },
    ],
  },
  // === ІСТОРІЯ УКРАЇНИ (11-15) ===
  {
    subject: 'Історія України',
    subjectKey: 'history',
    text: 'Пріоритет у зовнішній політиці князя Данила Романовича Галицького в другій половині 1240-х - 1260-х рр. полягав у',
    answers: [
      { letter: 'А', text: 'здобутті великокнязівського столу в Литві для свого сина Лева.', points: 0 },
      { letter: 'Б', text: 'зміцненні союзу з Польщею для відсічі агресії Тевтонського ордену.', points: 0 },
      { letter: 'В', text: 'створенні коаліції європейських держав для боротьби із Золотою Ордою.', points: 15 },
      { letter: 'Г', text: 'розширенні території держави за рахунок володінь Угорщини.', points: 0 },
    ],
  },
  {
    subject: 'Історія України',
    subjectKey: 'history',
    text: 'Наведена картосхема дає змогу визначити райони, охоплені повстанням проти Гетьмана',
    image: THEME_URL + '/assets/img/mini-nmt/12.webp',
    answers: [
      { letter: 'А', text: 'П. Тетері.', points: 0 },
      { letter: 'Б', text: 'І. Виговського.', points: 15 },
      { letter: 'В', text: 'І. Брюховецького.', points: 0 },
      { letter: 'Г', text: 'Д. Многогрішного.', points: 0 },
    ],
  },
  {
    subject: 'Історія України',
    subjectKey: 'history',
    text: 'Прочитайте уривок із джерела:\n<br><span>«Наказав сховати понад 300 єврейських дітей… і цінні єврейські документи… варто зауважити, що Митрополит приховував цю порятункову акцію від більшої частини духовенства тому, що цього потребували обставини».</span>\n<br>Це розпорядження віддав митрополит',
    answers: [
      { letter: 'А', text: 'Любомир Гузар.', points: 0 },
      { letter: 'Б', text: 'Йосип Сліпий.', points: 0 },
      { letter: 'В', text: 'Василь Липківський.', points: 0 },
      { letter: 'Г', text: 'Андрей Шептицький.', points: 10 },
    ],
  },
  {
    subject: 'Історія України',
    subjectKey: 'history',
    text: 'Укажіть одну з особливостей розвитку культури в Україні в період незалежності.',
    answers: [
      { letter: 'А', text: 'посилення ідеологічного тиску', points: 0 },
      { letter: 'Б', text: 'відсутність державного фінансування', points: 0 },
      { letter: 'В', text: 'зростання різноманіття мистецьких течій і напрямів', points: 10 },
      { letter: 'Г', text: 'послаблення залежності від економічних чинників', points: 0 },
    ],
  },
  {
    subject: 'Історія України',
    subjectKey: 'history',
    text: 'На фото зображено',
    image: THEME_URL + '/assets/img/mini-nmt/15.webp',
    answers: [
      { letter: 'А', text: 'Іллінську церкву в Суботові.', points: 0 },
      { letter: 'Б', text: 'церкву Зішестя Святого Духа в Потеличі.', points: 10 },
      { letter: 'В', text: 'Покровську церкву-фортецю в Сутківцях.', points: 0 },
      { letter: 'Г', text: 'Преображенську церкву у Великих Сорочинцях.', points: 0 },
    ],
  },
];

const RESULTS = {
  child: [
    {
      min: 0,
      max: 99,
      title: 'Цей результат не дав би пройти НМТ 😔',
      text: 'Але головне — ти вже знаєш, де прогалини. Математика, мова, історія — кожен предмет можна підтягнути з правильним підходом.',
      challengeText: 'Перевір, чи впорається твій однокласник краще 😏',
    },
    {
      min: 100,
      max: 179,
      title: 'Непоганий результат, але до топових університетів не вистачає 🎯',
      text: 'Для гарного вишу потрібно 180+. Ще є час це виправити.',
      challengeText: 'Кинь виклик другу — хто набере більше? 😏',
    },
    {
      min: 180,
      max: 200,
      title: 'Відмінний результат! З такими балами — будь-який університет твій 🏆',
      text: 'Подивимось, чи зможуть твої друзі повторити.',
      challengeText: 'Перевір, чи є серед друзів хтось крутіший 😏',
    },
  ],
  parent: [
    {
      min: 0,
      max: 99,
      title: 'З таким результатом НМТ не вдалося б скласти 😔',
      text: 'І це дорослій людині з досвідом. Уявіть, як складно це дається 16-річному школяру.',
      challengeText: 'Перевір, чи впораються інші батьки краще 😏',
    },
    {
      min: 100,
      max: 179,
      title: 'Ви б склали НМТ, але вибір університету був би обмеженим 🎯',
      text: 'А ваша дитина зможе показати такий самий результат?',
      challengeText: 'Поділіться з іншими батьками — цікаво, який результат у них 😏',
    },
    {
      min: 180,
      max: 200,
      title: 'З таким результатом ви б вступили до будь-якого університету 🏆',
      text: 'А ваша дитина зможе показати такий самий результат?',
      challengeText: 'Перевірте, чи впораються інші батьки так само добре 😏',
    },
  ],
};

const TOTAL = QUESTIONS.length;

const state = {
  userType: null,
  currentIndex: 0,
  score: 0,
};

function getTrackingParams() {
  const params = new URLSearchParams(window.location.search);
  const keys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'gclid', 'fbclid'];
  const result = {};
  keys.forEach((key) => {
    result[key] = params.get(key) || '';
  });
  return result;
}

const tracking = getTrackingParams();

const el = {
  intro: null,
  question: null,
  result: null,
  share: null,
  subjectBadge: null,
  counter: null,
  progressFill: null,
  questionText: null,
  questionImage: null,
  answersList: null,
  scoreEl: null,
  resultTitle: null,
  resultText: null,
  challengeText: null,
  shareUrl: null,
};

function initElements() {
  el.intro = document.querySelector('.mnmt-screen--intro');
  el.question = document.querySelector('.mnmt-screen--question');
  el.result = document.querySelector('.mnmt-screen--result');
  el.share = document.querySelector('.mnmt-share-overlay');
  el.subjectBadge = document.querySelector('.mnmt-subject-badge');
  el.counter = document.querySelector('.mnmt-counter-text');
  el.progressFill = document.querySelector('.mnmt-progress-fill');
  el.questionText = document.querySelector('.mnmt-question-text');
  el.questionImage = document.querySelector('.mnmt-question-image');
  el.answersList = document.querySelector('.mnmt-answers-list');
  el.scoreEl = document.querySelector('.mnmt-result-score');
  el.resultTitle = document.querySelector('.mnmt-result-title');
  el.resultText = document.querySelector('.mnmt-result-text');
  el.challengeText = document.querySelector('.mnmt-challenge-text');
  el.shareUrl = document.querySelector('.mnmt-share-url');
}

function showScreen(name) {
  [el.intro, el.question, el.result].forEach((s) => {
    if (s) s.hidden = true;
  });
  const target = el[name];
  if (target) target.hidden = false;
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

function renderQuestion(index) {
  const q = QUESTIONS[index];
  const questionNumber = index + 1;

  const SHORT_SUBJECTS = { ukr: 'Укр. мова' };
  const shortSubject = SHORT_SUBJECTS[q.subjectKey] || q.subject;
  el.subjectBadge.innerHTML = '<span class="mnmt-subject-badge__full">#' + q.subject + '</span>'
    + '<span class="mnmt-subject-badge__short">#' + shortSubject + '</span>';
  el.subjectBadge.className = 'mnmt-subject-badge mnmt-subject-badge--' + q.subjectKey;

  el.counter.textContent = questionNumber + '/' + TOTAL;

  const pct = Math.round((questionNumber / TOTAL) * 100);
  el.progressFill.style.width = pct + '%';

  el.questionText.innerHTML = q.text;

if (el.questionImage) {
    if (q.image) {
      el.questionImage.src = q.image;
      el.questionImage.hidden = false;
    } else {
      el.questionImage.hidden = true;
    }
  }

  const questionBox = document.querySelector('.mnmt-question-box');
  if (questionBox) {
    questionBox.className = 'mnmt-question-box mnmt-question-box--' + q.subjectKey;
  }

  el.answersList.innerHTML = '';
  q.answers.forEach((answer) => {
    const li = document.createElement('li');
    li.className = 'mnmt-answer-item';
    li.innerHTML =
      '<button class="mnmt-answer-btn" type="button">' +
      '<span class="mnmt-answer-circle"></span>' +
      '<span class="mnmt-answer-letter">' + answer.letter + '</span>' +
      '<span class="mnmt-answer-text">' + answer.text + '</span>' +
      '</button>';

    li.querySelector('.mnmt-answer-btn').addEventListener('click', () => {
      onAnswer(answer.points);
    });

    el.answersList.appendChild(li);
  });
}

function onAnswer(points) {
  state.score += points;
  state.currentIndex++;

  if (state.currentIndex < TOTAL) {
    renderQuestion(state.currentIndex);
  } else {
    showResult();
  }
}

function getResult() {
  const bucket = RESULTS[state.userType] || RESULTS.child;
  return bucket.find((r) => state.score >= r.min && state.score <= r.max) || bucket[0];
}

function showResult() {
  const result = getResult();

  el.scoreEl.textContent = state.score;
  el.resultTitle.textContent = result.title;
  el.resultText.textContent = result.text;
  el.challengeText.textContent = result.challengeText;

  showScreen('result');
  sendToKeyCRM();
}

function initShareLinks() {
  const url = 'https://pifagor-school.com.ua/mini-nmt-quiz/?utm_source=nmt_quiz&utm_medium=share';

  if (el.shareUrl) el.shareUrl.value = url;

  const copyBtn = document.querySelector('.mnmt-share-copy');
  if (copyBtn) {
    copyBtn.addEventListener('click', () => {
      navigator.clipboard.writeText(url).then(() => {
        alert('Посилання скопійовано!');
      });
    });
  }

  const shareText = encodeURIComponent('Пройди міні-тест НМТ і перевір свої знання! ');
  const encodedUrl = encodeURIComponent(url);

  const links = {
    threads: 'https://www.threads.net/share?url=' + encodedUrl,
    twitter: 'https://twitter.com/intent/tweet?url=' + encodedUrl + '&text=' + shareText,
    facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl,
    linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + encodedUrl,
    telegram: 'https://t.me/share/url?url=' + encodedUrl + '&text=' + shareText,
  };

  Object.entries(links).forEach(([network, href]) => {
    const btn = document.querySelector('.mnmt-share-social--' + network);
    if (btn) btn.href = href;
  });

  const instagramBtn = document.querySelector('.mnmt-share-social--instagram');
  if (instagramBtn) {
    instagramBtn.addEventListener('click', (e) => {
      e.preventDefault();
      navigator.clipboard.writeText(url);
    });
  }
}

function initShareToggle() {
  const openBtns = document.querySelectorAll('.mnmt-share-open');
  const closeBtn = document.querySelector('.mnmt-share-close');

  openBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      if (el.result) el.result.hidden = true;
      if (el.share) el.share.hidden = false;
    });
  });

  if (closeBtn) {
    closeBtn.addEventListener('click', () => {
      if (el.share) el.share.hidden = true;
      if (el.result) el.result.hidden = false;
    });
  }
}

function startQuiz() {
  state.currentIndex = 0;
  state.score = 0;
  showScreen('question');
  renderQuestion(0);
}

function sendToKeyCRM() {
  const nonce = window.MiniNMT && window.MiniNMT.nonce ? window.MiniNMT.nonce : '';
  const ajaxUrl = window.MiniNMT && window.MiniNMT.ajaxUrl ? window.MiniNMT.ajaxUrl : '/wp-admin/admin-ajax.php';

  fetch(ajaxUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    body: new URLSearchParams({
      action: 'mini_nmt_result',
      nonce: nonce,
      name: state.userName || '',
      phone: state.userPhone || '',
      who_takes: state.userWhoTakes || '',
      score: state.score,
      ...tracking,
    }),
  });
}

function initFormCapture() {
  const introSection = document.querySelector('.mnmt-screen--intro');
  if (!introSection) return;

  introSection.addEventListener(
    'submit',
    (e) => {
      const form = e.target;
      const select = form.querySelector('[name="who-takes"]');
      if (select) {
        state.userType = select.value === 'Батьки' ? 'parent' : 'child';
        state.userWhoTakes = select.value;
      }
      const nameField = form.querySelector('[name="your-name"]');
      if (nameField) state.userName = nameField.value;
      const phoneField = form.querySelector('[name="Phone_no_code"]');
      if (phoneField) state.userPhone = phoneField.value;
    },
    true,
  );

  document.addEventListener('wpcf7mailsent', (e) => {
    const form = e.target;
    if (!form.closest('.mnmt-screen--intro')) return;
    startQuiz();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  if (!document.querySelector('.mnmt-screen--intro')) return;

  initElements();
  initFormCapture();
  initShareLinks();
  initShareToggle();
});
